<script setup>
import Lock from "../../../../franchise-listings/assets/svg/LockSimple.svg";
import {defineProps, ref, watch} from "vue";
import NextButton from "../NextButton.vue";
import ResendCodeTimer from "../ResendCodeTimer.vue";
import PrevButton from "../PrevButton.vue";
import debounce from "../../debounce";

const {flowState} = defineProps(['visible', 'flowState']);

const errors = ref({
  code: false,
});

//let interval;

const smsCode = ref();

const onSmsCodeChange = (e) => {
  smsCode.value = e.target.value.trim();
}

const verifyCode = async () => {


  // Hide button and show loader
  $('.btn-next').hide();
  $('.btn-prev').hide();
  $('.btn-resend').hide();
  $('#loadingBtn').show();

  // Clear error messages
  $('#showPhoneErrorMessage').hide();
  $('#showAttemptsErrorMessage').hide();
  $('#showSomethingWrongErrorMessage').hide();

  try {
    // Validate phone number and SMS code value
    const phoneNumberValidationRequestId = flowState.getPhoneNumberValidationRequestId();

    await flowState.services.verifyCode(
        phoneNumberValidationRequestId,
        smsCode.value
    );

      // Stop CountDown
      flowState.stopCountdown();

    // Send data to Hubspot
    flowState.setHubspotStatus();

    // Move to next step
    flowState.next();
  } catch (e) {
    console.log(e)
  }
};

const checkAttempts = () => {
  return flowState.getVerifyAttempts() <= 3;
}

const resendCode = async () => {
  flowState.services.cancelRequest(flowState.getPhoneNumberValidationRequestId());
  flowState.stopCountdown();

  // Hide button and show loader
  $('.btn-next').hide();
  $('.btn-prev').hide();
  $('.btn-resend').hide();
  $('#loadingBtn').show();

  // Clear error messages
  $('#showPhoneErrorMessage').hide();
  $('#showAttemptsErrorMessage').hide();
  $('#showSomethingWrongErrorMessage').hide();

  if (checkAttempts()) {
    try {

        // Validate phone number and send verification code to user
        setTimeout(
            async function () {
                await flowState.services.resendCode(flowState.fullPhoneNumber(), function (response) {
                    $('.btn-next').show();
                    $('.btn-prev').show();
                    $('.btn-resend').show();
                    $('#loadingBtn').hide();

                    flowState.setPhoneNumberValidationRequestId(response['request']);

                    // Update verify attempts and start countdown after SMS sent
                    flowState.updateVerifyAttempts();
                    flowState.startCountdown();
                });
            }, 5000);

    } catch (e) {
      console.log(e)
    }
  } else {
    $('#showAttemptsErrorMessage').show();
  }

}

// Go back -> Update phone number
const backToStepTwo = () => {
  flowState.stopCountdown();
  flowState.services.cancelRequest(flowState.getPhoneNumberValidationRequestId());
  flowState.prev();
  flowState.setBackToStep2();
}

let timer = ref(flowState.getTimeRemaining());
let interval = ref();

const startTimer = () => {
  interval = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    }
    else if(timer.value === 0) {
      clearInterval(interval);
      resendCode();
    }
  }, 1000);
}

watch(
    () => flowState.getCountDownStatus(),
    debounce(() => {
        if (flowState.getCountDownStatus()) {
            startTimer()
        } else {
            if (timer !== flowState.getTimeRemaining()) {
                timer.value = flowState.getTimeRemaining();
                clearInterval(interval);
            }
        }
    }, 1000)
);

</script>

<template>
  <div v-if="visible">
    <div class="tab">
      <div class="row pb-3">
        <p>
          We sent a confirmation code to <span class="fw-bold" id="fullNumber">{{ flowState.fullPhoneNumber() }}</span>.
          Enter your code below, hit submit to continue, and then keep an eye out for franchise updates.
        </p>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <p class="small-text-bold mb-2">
            4 digit confirmation code<span class="text-danger ms-1">*</span>
          </p>
          <p>
            <input
                type="text"
                maxlength="4"
                placeholder=""
                @focusout="onSmsCodeChange"
            />
          </p>
        </div>
      </div>

      <div id="codeErrorMessage" class="row p-3 mt-3 pb-0">
        <div class="col col-12 p-3 mb-0">
          <p class="mb-0 d-flex justify-content-start align-items-center">
            <Lock/>
            Your code validation failed. Please try again or resend a request for a new code.
          </p>
        </div>
      </div>
    </div>

    <div id="showAttemptsErrorMessage" class="row p-3 mt-3 pb-0">
      <div class="col col-12 p-3 mb-0">
        <p class="mb-0 d-flex justify-content-start align-items-center">
          <Lock/>
          You have reached the limit of 3 resending verification codes.
        </p>
      </div>
    </div>

    <div id="showSomethingWrongErrorMessage" class="row p-3 mt-3 pb-0">
      <div class="col col-12 p-3 mb-0">
        <p class="mb-0 d-flex justify-content-start align-items-center">
          <Lock/>
          Something went wrong while trying to resend code. Please check and update your phone number and try again.
        </p>
      </div>
    </div>

    <div>
      <NextButton
          :text="flowState.nextButtonText()"
          :enabled="true"
          @click="() => { verifyCode() }"
      />
      <div id="loadingBtn" class="mt-5">
        <span id="loader"></span>
      </div>


        <template v-if="flowState.getCountDownStatus()">
            <template v-if="timer >= 30">
                <ResendCodeTimer
                        class="btn-disabled"
                        title="Button will be enabled in 30 seconds"
                        :text="timer"
                        @click="() => { resendCode() }"
                />
                <PrevButton
                        v-if="!flowState.getBackToStep2()"
                        :text="flowState.prevButtonText()"
                        :enabled="false"
                        class="btn-disabled"
                        title="Button will be enabled in 30 seconds"
                        @click="() => { backToStepTwo() }"
                />
            </template>
            <template v-else-if="timer < 30">
                <ResendCodeTimer
                        :text="timer"
                        @click="() => { resendCode() }"
                />
                <PrevButton
                        v-if="!flowState.getBackToStep2()"
                        :text="flowState.prevButtonText()"
                        :enabled="true"
                        @click="() => { backToStepTwo() }"
                />
            </template>
        </template>
    </div>
  </div>
</template>